import {Component, input, signal} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {GenerateCredentialResponse} from '../../../../../../../api';
import {ElciaIcon} from '../../../../../../components/icon/icon';

@Component({
  selector: 'elcia-licence-server-credentials-dialog',
  imports: [TranslatePipe, ElciaIcon],
  templateUrl: './licence-server-credentials-dialog.html',
})
export class LicenceServerCredentialsDialog {
  credentials = input.required<GenerateCredentialResponse>();

  // Toggles each copy icon to a checkmark briefly after copying, as a visual confirmation.
  protected readonly clientIdCopied = signal(false);
  protected readonly clientSecretCopied = signal(false);

  protected async copyClientId(): Promise<void> {
    await navigator.clipboard.writeText(this.credentials().clientId);
    this.clientIdCopied.set(true);
    setTimeout(() => this.clientIdCopied.set(false), 1500);
  }

  protected async copyClientSecret(): Promise<void> {
    await navigator.clipboard.writeText(this.credentials().clientSecret);
    this.clientSecretCopied.set(true);
    setTimeout(() => this.clientSecretCopied.set(false), 1500);
  }
}
